// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilePptOutlinedSvg from "@fishx/icons-svg/es/asn/FilePptOutlined";
import FishxIcon from '../components/FishxIcon';

var FilePptOutlined = function FilePptOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilePptOutlinedSvg
  }));
};

FilePptOutlined.displayName = 'FilePptOutlined';
export default React.forwardRef(FilePptOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FilePptOutlined.js
// module id = 2738
// module chunks = 0